import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import { getEnvironmentType } from "../contexts/useEnvType";
import { environment } from "../environment";

const { isGov } = getEnvironmentType();
const writeKey = environment.VITE_CUSTOMER_IO_SDK_KEY;
const siteId = environment.VITE_CUSTOMER_IO_SITE_ID;

export const cioAnalytics =
  !isGov && writeKey
    ? AnalyticsBrowser.load(
        { writeKey },
        siteId
          ? {
              integrations: {
                "Customer.io In-App Plugin": {
                  siteId,
                  colorScheme: "auto",
                },
              },
            }
          : undefined
      )
    : null;
